import { render, staticRenderFns } from "./FundChartLegend.vue?vue&type=template&id=1cd76c24&scoped=true&"
import script from "./FundChartLegend.vue?vue&type=script&lang=js&"
export * from "./FundChartLegend.vue?vue&type=script&lang=js&"
import style0 from "./FundChartLegend.vue?vue&type=style&index=0&id=1cd76c24&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd76c24",
  null
  
)

export default component.exports